import { __extends } from "tslib";
import { RenderHtml } from '../../../utils';
import * as React from 'react';
import { classNames } from '@wix/answers-lib';
export var TOTAL_CELL_PADDING = 50;
var TableComponent = /** @class */ (function (_super) {
    __extends(TableComponent, _super);
    function TableComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getColWidthStyle = function (col, overridenColumnWidths) {
            return { width: overridenColumnWidths[col] - TOTAL_CELL_PADDING };
        };
        return _this;
    }
    TableComponent.prototype.renderTableRow = function (row, idx) {
        var rowComp = row.map(function (cellContent, rowIndex) {
            return React.createElement("td", { key: rowIndex, className: 'table-cell' },
                React.createElement(RenderHtml, { html: cellContent, className: 'rendered-html' }));
        });
        return (React.createElement("tr", { key: idx, className: 'table-row content-row' }, rowComp));
    };
    TableComponent.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var headings = props.value.headings;
        var cells = props.value.cells;
        var widths = props.value.columnWidths;
        var tableHeading = headings.map(function (heading, idx) { return (React.createElement("th", { key: idx, style: widths ? _this.getColWidthStyle(idx, widths) : undefined, className: 'table-cell heading-cell' },
            React.createElement(RenderHtml, { html: heading, className: 'rendered-html' }))); });
        var tableWrapperClasses = classNames([
            'table-wrapper',
            { 'overriden-width': !!widths }
        ]);
        return (React.createElement("div", { className: classNames('component', 'table-component', this.props.direction), "data-component-type": 'table' },
            React.createElement("div", { className: tableWrapperClasses },
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", { className: 'table-row heading-row' }, tableHeading)),
                    React.createElement("tbody", null, cells.map(function (row, idx) { return _this.renderTableRow(row, idx); }))))));
    };
    return TableComponent;
}(React.Component));
export { TableComponent };
//# sourceMappingURL=table-component.comp.js.map